import { lazy, Suspense, useContext, useRef } from 'react';

import { ModalContext } from 'providers/modal-provider';
import ReactDOM from 'react-dom';
import { useOnClickOutside } from 'hooks/useOnClickOutside';

export function DynamicModal(): JSX.Element | null {
  const { setActive, active, modalType, modalProps } = useContext(ModalContext);
  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => setActive(false));

  if (!active) return null;
  const node = document.getElementById('root');
  return (
    <Suspense fallback={null}>
      {((): JSX.Element | null => {
        switch (modalType) {
          case 'SaveSearchFiltersGroupModal': {
            const SaveSearchFiltersGroupModal = lazy(() => import('./SaveSearchFiltersGroupModal'));
            return <SaveSearchFiltersGroupModal {...modalProps} onClose={(): void => setActive(false)} />;
          }
          case 'Popup': {
            const Popup = lazy(() => import('../Popup'));
            //setTimeout(() => setActive(false), 8000);
            return ReactDOM.createPortal(
              <Popup {...modalProps} isActive={active} onClose={(): void => setActive(false)} />,
              node as HTMLElement
            );
          }
          case 'info': {
            const PopupInfo = lazy(() => import('../PopupInfo'));
            //setTimeout(() => setActive(false), 8000);
            return ReactDOM.createPortal(
              <PopupInfo {...modalProps} isActive={active} onClose={(): void => setActive(false)} />,
              node as HTMLElement
            );
          }
          case 'MarketingYearsSelectModal': {
            const MarketingYearsSelectModal = lazy(() => import('./MarketingYearsSelectModal'));
            return (
              <MarketingYearsSelectModal
                onChange={(e): void => {
                  modalProps.onSelected(e);
                  setActive(false);
                }}
                options={modalProps.options}
                onClose={(): void => setActive(false)}
              />
            );
          }
          case 'ModelVersionSelectModal': {
            const ModelVersionSelect = lazy(() => import('./ModelVersionSelectModal'));
            return (
              <ModelVersionSelect
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                onChange={(e: Array<{ label: string; value: string }>): void => {
                  modalProps.onSelectedVersion(e);
                  setActive(false);
                }}
                options={modalProps.versions as unknown as Array<{ label: string; value: string }>}
                onClose={(): void => setActive(false)}
              />
            );
          }
          default:
            return null;
        }
      })()}
    </Suspense>
  );
}
